// extracted by mini-css-extract-plugin
export default {"title":"RWs_g","answers":"p2t3Y","answer":"vQuYM","answerMenu":"FDm8U","addBtn":"T_VR9"};